/**
 * GA4 event tracking utility.
 * Uses the global gtag() injected via index.html.
 */

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export function gtagEvent(eventName, params = {}) {
  if (typeof window.gtag === 'function' && GA_ID) {
    window.gtag('event', eventName, params);
  }
}

export function gtagPageView(pagePath, pageTitle) {
  if (typeof window.gtag === 'function' && GA_ID) {
    window.gtag('config', GA_ID, {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
}
